export default {
  customPages: [],
};
